
import styles from "../styles/mobileRow.module.css";
import { useState } from "react";
import { patchItem } from "../api/Api";

function MobileRow(props) {

    // ---------------------------------------------------------------- state and hooks

    const [isEditing, setIsEditing] = useState(false);
    const [name, setName] = useState(props.item.name);
    const [editedName, setEditedName] = useState(props.item.name);
    const [details, setDetails] = useState(props.item.details || '');
    const [editedDetails, setEditedDetails] = useState(props.item.details || '');

    const currentUser = sessionStorage.getItem('user');
    const isClaimed = props.item.claimerNames?.includes(currentUser);

    // ---------------------------------------------------------------- logic

    function toggleClaimHandler() {
        if (isClaimed) {
            props.unclaimItemHandler()
        } else {
            props.claimItemHandler();
        }
    }

    async function saveChanges() {
        setIsEditing(false);

        const updatesObj = {
            name: editedName,
            details: editedDetails,
        };
        await patchItem(props.item.id, updatesObj).then((result) => {
            setName(result.name);
            setDetails(result.details);
        });
    }

    function discardChanges() {
        setIsEditing(false);
        setEditedName(name);
        setEditedDetails(details);
    }

    // ---------------------------------------------------------------- render

    let rowItem;

    if (currentUser !== props.item.creatorName) {
        // NOT created by current user, return simple claim/unclaimable row
        rowItem = (
            <div className={isClaimed ? styles.claimedContainer : styles.container}>
                <h2 className={styles.title}>{name}</h2>
                <h5 className={styles.details}>{details}</h5>
                {genClaimers()}
                <button onClick={toggleClaimHandler} className={styles.actionButton}>{isClaimed ? "Unclaim" : "Claim"}</button>
            </div>
        );

    } else if (isEditing) {
        // created by user and editing, row in edit mode
        rowItem = (
            <div className={styles.container}>
                <input
                    style={{ width: 'calc(100% - 10px)', marginLeft: '0px' }}
                    maxLength={50}
                    value={editedName}
                    onChange={(event) => setEditedName(event.target.value)}
                    className={styles.titleInput}
                />
                <textarea
                    style={{ width: 'calc(100% - 10px)' }}
                    value={editedDetails}
                    onChange={(event) => setEditedDetails(event.target.value)}
                    rows={10}
                    className={styles.detailsInput}
                />
                <div className={styles.buttons}>
                    <button
                        className={styles.actionButton}
                        onClick={saveChanges}>
                        Save
                    </button>
                    <button onClick={discardChanges} className={styles.actionButton}>Cancel</button>
                </div>
            </div>
        );

    } else {
        // created by current user and not editing, full edit options
        rowItem = (
            <div className={isClaimed ? styles.claimedContainer : styles.container}>
                <h2 className={styles.title}>{name}</h2>
                <h5 className={styles.details}>{details}</h5>
                {genClaimers()}
                <div className={styles.buttons}>
                    {props.item.askerName === currentUser ?
                        <></>
                        :
                        <button onClick={toggleClaimHandler} className={styles.actionButton}>{isClaimed ? "Unclaim" : "Claim"}</button>
                    }
                    <button onClick={() => setIsEditing(true)} className={styles.actionButton}>Edit</button>
                    <button onClick={props.deleteItemHandler} className={styles.actionButton}>Delete</button>
                </div>
            </div>
        );
    }

    // ---------------------------------------------------------------- return

    return (
        <div>{rowItem}</div>
    )

    // ---------------------------------------------------------------- helpers

    function genClaimers() {
        // makes claimer string 

        let numClaimers = Number(props.item.claimerNames?.length);

        if (numClaimers === 0 || numClaimers === null) {
            // NO claimers
            return (
                <></>
            );
        } else if (numClaimers === 1) {
            return (
                <div className={styles.claimedBy}>
                    Claimed by {props.item.claimerNames[0]}
                </div>
            )
        } else if (numClaimers === 2) {
            return (
                <div className={styles.claimedBy}>
                    Claimed by {props.item.claimerNames[0]} and {props.item.claimerNames[1]}
                </div>
            ); 
        } else if (numClaimers >= 3) {
            // 3 or more

            let claimerString = "";
            for (let i = 0; i < numClaimers; i++) {
                if (i !== numClaimers - 1) {
                    claimerString = claimerString  + props.item.claimerNames[i] + ", ";
                }
                else {
                    claimerString = claimerString + " and " + props.item.claimerNames[i];
                }
            }
            
            return (
                <div className={styles.claimedBy}>
                    Claimed by {claimerString}
                </div>
            )   
        }
    }
}

export default MobileRow;